/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as ErrorRouteImport } from './routes/_error'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as Error500RouteImport } from './routes/_error/500'
import { Route as Error403RouteImport } from './routes/_error/403'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AppResourcesRouteImport } from './routes/_app/resources'
import { Route as AppHelpCenterRouteImport } from './routes/_app/help-center'
import { Route as AppChatRouteImport } from './routes/_app/chat'
import { Route as AdminHelpCenterIndexRouteImport } from './routes/admin/help-center/index'
import { Route as AppChatIndexRouteImport } from './routes/_app/chat/index'
import { Route as AdminHelpCenterReleaseNotesRouteImport } from './routes/admin/help-center/release-notes'
import { Route as AdminHelpCenterFaqRouteImport } from './routes/admin/help-center/faq'
import { Route as AppChatChatIdRouteImport } from './routes/_app/chat/$chatId'

const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/_error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const Error500Route = Error500RouteImport.update({
  id: '/500',
  path: '/500',
  getParentRoute: () => ErrorRoute,
} as any)
const Error403Route = Error403RouteImport.update({
  id: '/403',
  path: '/403',
  getParentRoute: () => ErrorRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRoute,
} as any)
const AppResourcesRoute = AppResourcesRouteImport.update({
  id: '/resources',
  path: '/resources',
  getParentRoute: () => AppRoute,
} as any)
const AppHelpCenterRoute = AppHelpCenterRouteImport.update({
  id: '/help-center',
  path: '/help-center',
  getParentRoute: () => AppRoute,
} as any)
const AppChatRoute = AppChatRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => AppRoute,
} as any)
const AdminHelpCenterIndexRoute = AdminHelpCenterIndexRouteImport.update({
  id: '/help-center/',
  path: '/help-center/',
  getParentRoute: () => AdminRoute,
} as any)
const AppChatIndexRoute = AppChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppChatRoute,
} as any)
const AdminHelpCenterReleaseNotesRoute =
  AdminHelpCenterReleaseNotesRouteImport.update({
    id: '/help-center/release-notes',
    path: '/help-center/release-notes',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminHelpCenterFaqRoute = AdminHelpCenterFaqRouteImport.update({
  id: '/help-center/faq',
  path: '/help-center/faq',
  getParentRoute: () => AdminRoute,
} as any)
const AppChatChatIdRoute = AppChatChatIdRouteImport.update({
  id: '/$chatId',
  path: '/$chatId',
  getParentRoute: () => AppChatRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/chat': typeof AppChatRouteWithChildren
  '/help-center': typeof AppHelpCenterRoute
  '/resources': typeof AppResourcesRoute
  '/sign-in': typeof AuthSignInRoute
  '/403': typeof Error403Route
  '/500': typeof Error500Route
  '/admin/': typeof AdminIndexRoute
  '/chat/$chatId': typeof AppChatChatIdRoute
  '/admin/help-center/faq': typeof AdminHelpCenterFaqRoute
  '/admin/help-center/release-notes': typeof AdminHelpCenterReleaseNotesRoute
  '/chat/': typeof AppChatIndexRoute
  '/admin/help-center/': typeof AdminHelpCenterIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/help-center': typeof AppHelpCenterRoute
  '/resources': typeof AppResourcesRoute
  '/sign-in': typeof AuthSignInRoute
  '/403': typeof Error403Route
  '/500': typeof Error500Route
  '/admin': typeof AdminIndexRoute
  '/chat/$chatId': typeof AppChatChatIdRoute
  '/admin/help-center/faq': typeof AdminHelpCenterFaqRoute
  '/admin/help-center/release-notes': typeof AdminHelpCenterReleaseNotesRoute
  '/chat': typeof AppChatIndexRoute
  '/admin/help-center': typeof AdminHelpCenterIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/_error': typeof ErrorRouteWithChildren
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/_app/chat': typeof AppChatRouteWithChildren
  '/_app/help-center': typeof AppHelpCenterRoute
  '/_app/resources': typeof AppResourcesRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_error/403': typeof Error403Route
  '/_error/500': typeof Error500Route
  '/admin/': typeof AdminIndexRoute
  '/_app/chat/$chatId': typeof AppChatChatIdRoute
  '/admin/help-center/faq': typeof AdminHelpCenterFaqRoute
  '/admin/help-center/release-notes': typeof AdminHelpCenterReleaseNotesRoute
  '/_app/chat/': typeof AppChatIndexRoute
  '/admin/help-center/': typeof AdminHelpCenterIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/admin'
    | '/chat'
    | '/help-center'
    | '/resources'
    | '/sign-in'
    | '/403'
    | '/500'
    | '/admin/'
    | '/chat/$chatId'
    | '/admin/help-center/faq'
    | '/admin/help-center/release-notes'
    | '/chat/'
    | '/admin/help-center/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/help-center'
    | '/resources'
    | '/sign-in'
    | '/403'
    | '/500'
    | '/admin'
    | '/chat/$chatId'
    | '/admin/help-center/faq'
    | '/admin/help-center/release-notes'
    | '/chat'
    | '/admin/help-center'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/_error'
    | '/about'
    | '/admin'
    | '/_app/chat'
    | '/_app/help-center'
    | '/_app/resources'
    | '/_auth/sign-in'
    | '/_error/403'
    | '/_error/500'
    | '/admin/'
    | '/_app/chat/$chatId'
    | '/admin/help-center/faq'
    | '/admin/help-center/release-notes'
    | '/_app/chat/'
    | '/admin/help-center/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  ErrorRoute: typeof ErrorRouteWithChildren
  AboutRoute: typeof AboutRoute
  AdminRoute: typeof AdminRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_error': {
      id: '/_error'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_error/500': {
      id: '/_error/500'
      path: '/500'
      fullPath: '/500'
      preLoaderRoute: typeof Error500RouteImport
      parentRoute: typeof ErrorRoute
    }
    '/_error/403': {
      id: '/_error/403'
      path: '/403'
      fullPath: '/403'
      preLoaderRoute: typeof Error403RouteImport
      parentRoute: typeof ErrorRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/resources': {
      id: '/_app/resources'
      path: '/resources'
      fullPath: '/resources'
      preLoaderRoute: typeof AppResourcesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/help-center': {
      id: '/_app/help-center'
      path: '/help-center'
      fullPath: '/help-center'
      preLoaderRoute: typeof AppHelpCenterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chat': {
      id: '/_app/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof AppChatRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/help-center/': {
      id: '/admin/help-center/'
      path: '/help-center'
      fullPath: '/admin/help-center/'
      preLoaderRoute: typeof AdminHelpCenterIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_app/chat/': {
      id: '/_app/chat/'
      path: '/'
      fullPath: '/chat/'
      preLoaderRoute: typeof AppChatIndexRouteImport
      parentRoute: typeof AppChatRoute
    }
    '/admin/help-center/release-notes': {
      id: '/admin/help-center/release-notes'
      path: '/help-center/release-notes'
      fullPath: '/admin/help-center/release-notes'
      preLoaderRoute: typeof AdminHelpCenterReleaseNotesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/help-center/faq': {
      id: '/admin/help-center/faq'
      path: '/help-center/faq'
      fullPath: '/admin/help-center/faq'
      preLoaderRoute: typeof AdminHelpCenterFaqRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_app/chat/$chatId': {
      id: '/_app/chat/$chatId'
      path: '/$chatId'
      fullPath: '/chat/$chatId'
      preLoaderRoute: typeof AppChatChatIdRouteImport
      parentRoute: typeof AppChatRoute
    }
  }
}

interface AppChatRouteChildren {
  AppChatChatIdRoute: typeof AppChatChatIdRoute
  AppChatIndexRoute: typeof AppChatIndexRoute
}

const AppChatRouteChildren: AppChatRouteChildren = {
  AppChatChatIdRoute: AppChatChatIdRoute,
  AppChatIndexRoute: AppChatIndexRoute,
}

const AppChatRouteWithChildren =
  AppChatRoute._addFileChildren(AppChatRouteChildren)

interface AppRouteChildren {
  AppChatRoute: typeof AppChatRouteWithChildren
  AppHelpCenterRoute: typeof AppHelpCenterRoute
  AppResourcesRoute: typeof AppResourcesRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppChatRoute: AppChatRouteWithChildren,
  AppHelpCenterRoute: AppHelpCenterRoute,
  AppResourcesRoute: AppResourcesRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthSignInRoute: typeof AuthSignInRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthSignInRoute: AuthSignInRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface ErrorRouteChildren {
  Error403Route: typeof Error403Route
  Error500Route: typeof Error500Route
}

const ErrorRouteChildren: ErrorRouteChildren = {
  Error403Route: Error403Route,
  Error500Route: Error500Route,
}

const ErrorRouteWithChildren = ErrorRoute._addFileChildren(ErrorRouteChildren)

interface AdminRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
  AdminHelpCenterFaqRoute: typeof AdminHelpCenterFaqRoute
  AdminHelpCenterReleaseNotesRoute: typeof AdminHelpCenterReleaseNotesRoute
  AdminHelpCenterIndexRoute: typeof AdminHelpCenterIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
  AdminHelpCenterFaqRoute: AdminHelpCenterFaqRoute,
  AdminHelpCenterReleaseNotesRoute: AdminHelpCenterReleaseNotesRoute,
  AdminHelpCenterIndexRoute: AdminHelpCenterIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  ErrorRoute: ErrorRouteWithChildren,
  AboutRoute: AboutRoute,
  AdminRoute: AdminRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
